<script lang="ts">
	import Placeholder from './Placeholder.svelte';
	import { _ } from 'svelte-i18n';
</script>

<div class="info">{$_('post.sparq3ActivitiesAdminPlaceholder')}</div>
<ul class="activity-list">
	<Placeholder />
	<Placeholder />
	<Placeholder />
	<Placeholder />
	<Placeholder />
</ul>

<style>
	.info {
		padding: var(--gutterMedium);
		color: var(--grayMedium);
		font-size: var(--forSizeSmall);
	}

	ul.activity-list {
		inline-size: 100%;
		margin: 0;
		padding-block: 0;
		padding-inline: var(--gutterMedium);
	}
</style>
